module.exports = __webpack_public_path__ + "static/code-mobile-26d0324fdb4b8d7c2cb2adf1071c27ac.png";